export enum Events {
  CHANGE = 'change',
}



// WEBPACK FOOTER //
// ./src/pages/profile/components/selectcount/enums.ts